<h1 mat-dialog-title i18n>Work Order Resources</h1>
<div mat-dialog-content>
  <p i18n>Work Order Resources are reserved to a particular location at a given date and time.</p>
  <form #resourceForm="ngForm" (ngSubmit)="updateResource(resourceForm)">
    <div class="modal-body">
      <div *ngFor="let resourceType of data.resourceTypes">
        <div>
          <div class="form-group row">

            <div class="col-sm-9">
              <b>{{resourceType.resourceType_Desc}}</b>
            </div>
            <div class="col-sm-3">
              <b i18n>Notes</b>
            </div>

          </div>

          <div *ngFor="let resource of resourceType.resources" class="form-group row">
            <div class="col-sm-9">
              <input name="isSelected{{resource.resource_ID}}" type="checkbox"
                     [(ngModel)]="resource.isSelected" #isSelected="ngModel" />
              {{resource.resource_Name}}
            </div>
            <div class="col-sm-3">
              <input name="workOrderResource_Note{{resource.resource_ID}}" type="text" class="form-control"
                     [(ngModel)]="resource.workOrderResource_Note" #workOrderResource_Note="ngModel" />
            </div>
          </div>

        </div>
      </div>
    </div>
    <div [hidden]="!resourceForm.submitted || resourceForm.valid"
         class="mt-3 alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    <div>
      <div *ngIf="!isRequesting">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Submit</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
</div>
